import { render } from "./TherapyH5VirtualPhoneManagement.vue?vue&type=template&id=16aa21e2&scoped=true"
import script from "./TherapyH5VirtualPhoneManagement.vue?vue&type=script&lang=js"
export * from "./TherapyH5VirtualPhoneManagement.vue?vue&type=script&lang=js"

import "./TherapyH5VirtualPhoneManagement.vue?vue&type=style&index=0&id=16aa21e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16aa21e2"]])

export default __exports__